import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1ab3d102"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navLeft" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MENU = _resolveComponent("MENU")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_menu, {
      collapse: _ctx.state.isSidebarNavCollapse,
      "default-active": _ctx.state.currentMenu,
      id: "menu",
      "text-color": "#7E85A0",
      "active-text-color": "#6B86FF",
      "unique-opened": true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_MENU, {
          menuList: _ctx.state.sidebarMenu
        }, null, 8, ["menuList"])
      ]),
      _: 1
    }, 8, ["collapse", "default-active"])
  ]))
}